import { keysToCamelCase } from "@jti/fe-common";
import type {
  ApiMagentoGetShippingMethods,
  MagentoSelectedShippingMethod,
  MagentoShippingMethod,
} from "@jti/magento-types";

import { mockApiShippingMethods } from "./shippingMethods.mock";

const availableShippingMethod = mockApiShippingMethods[0];
const selectedShippingMethod = {
  carrier_code: availableShippingMethod.carrier_code,
  method_code: availableShippingMethod.method_code,
  amount: availableShippingMethod.amount,
  method_title: availableShippingMethod.method_title,
};

export const getShippingMethodsApiResponseMock = (): ApiMagentoGetShippingMethods => {
  return {
    cart: {
      shipping_addresses: [
        {
          available_shipping_methods: mockApiShippingMethods,
          selected_shipping_method: selectedShippingMethod,
        },
      ],
    },
  };
};

export const getShippingMethodsMock: {
  methods: MagentoShippingMethod[];
  methodSelected: MagentoSelectedShippingMethod | null;
} = {
  methods: keysToCamelCase(mockApiShippingMethods),
  methodSelected: keysToCamelCase(selectedShippingMethod),
};
